import { Link } from "react-router-dom";
import { CalendarDays, Users } from "lucide-react";
import { Avatar } from "./Placeholder";
import { useI18n } from "../../lib/i18n";
import { fmtDayTime, money } from "../../lib/format";

const SUBJECT_COLORS = ["bg-[#CFE3FB] text-osk-navy", "bg-[#FDDCCB] text-osk-navy", "bg-[#E3DBFA] text-osk-navy", "bg-[#CFF1E2] text-osk-navy", "bg-[#FFF0C2] text-osk-navy"];
const colorFor = (s) => SUBJECT_COLORS[[...(s || "")].reduce((a, c) => a + c.charCodeAt(0), 0) % SUBJECT_COLORS.length];

export const SeatsText = ({ n, testid }) => {
  const { t } = useI18n();
  const urgent = n <= 3;
  const label = n <= 0 ? t("card.full") : n === 1 ? t("card.seat1") : t("card.seats", { n });
  return <span data-testid={testid} className={urgent ? "font-bold text-osk-red" : "text-osk-text"}>{label}</span>;
};

export const LessonCard = ({ lesson, className = "" }) => {
  const { t, lang } = useI18n();
  return (
    <Link to={`/lessen/${lesson.id}`} data-testid={`lesson-card-${lesson.id}`}
      className={`osk-card osk-hover-lift flex flex-col gap-4 p-5 ${className}`}>
      <div className="flex flex-wrap gap-2">
        <span className={`osk-pill ${colorFor(lesson.subject)}`}>{lesson.subject}</span>
        <span className="osk-pill bg-slate-100 text-osk-navy">{lesson.school_type}</span>
        <span className="osk-pill bg-slate-100 text-osk-navy">{lesson.grade}</span>
      </div>
      <div className="flex items-center gap-3">
        <Avatar fileId={lesson.teacher_photo} name={lesson.teacher_name} size={52} />
        <div className="min-w-0">
          <p className="truncate font-bold text-osk-navy">{lesson.teacher_name}</p>
          <p className="truncate text-xs text-osk-muted">{lesson.title}</p>
        </div>
      </div>
      <div className="mt-auto flex items-end justify-between gap-3 text-sm">
        <div className="space-y-1.5">
          <p className="flex items-center gap-2 whitespace-nowrap text-[13px] text-osk-text"><CalendarDays className="h-4 w-4 text-osk-navy" />{lesson.next_start ? fmtDayTime(lesson.next_start, lesson.next_end, lang) : "-"}</p>
          <p className="flex items-center gap-2"><Users className={`h-4 w-4 ${lesson.seats_left <= 3 ? "text-osk-red" : "text-osk-navy"}`} /><SeatsText n={lesson.seats_left} testid={`lesson-card-seats-${lesson.id}`} /></p>
        </div>
        <div className="shrink-0 text-right leading-tight" data-testid={`lesson-card-price-${lesson.id}`}>
          <p className="whitespace-nowrap text-base font-extrabold text-osk-navy">{money(lesson.price, lesson.currency)}</p>
          <p className="text-xs text-osk-muted">{t("card.per")}</p>
        </div>
      </div>
    </Link>
  );
};
